import { FieldType } from '@/catalog/constants/fieldTypes';
import { Field } from '@/catalog/types/field';
import { ALL_CONTEXTS } from '@/common/constants/context';
import { SetupPresetGroupType } from '@/media/entity/SetupPresetGroup';
import MetricScaleContainer from '@/metric/components/MetricScaleContainer/MetricScaleContainer';
import OptMetricBar from '@/metric/components/OptMetricBar/OptMetricBar';
import { METRIC_DATA_DECORATOR_ROUND } from '@/metric/constants/dataDecorators';
import Diamond from '@/product/entity/Diamond';

export const FIELD_CUT_PERFORMANCE_V2: Field = {
  key: 'integralV2.val',
  label: 'Global Perf. v2 (Beta)',
  fullLabel: 'Global Perf. v2 (Beta)',
  type: FieldType.Metric,
  spGroupId: SetupPresetGroupType.FireDiBOX,
  icon: 'metrics-optical-performance',
  getValue(p) {
    if (p instanceof Diamond && p.integralV2Metric) {
      return p.integralV2Metric.val;
    }

    return null;
  },
  getText(p) {
    if (p instanceof Diamond && p.integralV2Metric) {
      return p.integralV2Metric.global.hr;
    }

    return null;
  },
  render(p, { ratio, size, label, icon, metricClassName, isMetricInCard } = {}) {
    if (p instanceof Diamond) {
      return (
        <OptMetricBar
          cutShapeId={p.cutShapeId}
          metric={p.integralV2Metric}
          metricDataDecorator={METRIC_DATA_DECORATOR_ROUND}
          ratio={ratio}
          type="integralV2"
        >
          {(scale, abs) => (
            <MetricScaleContainer
              abs={abs}
              icon={icon}
              className={metricClassName}
              inCard={isMetricInCard}
              isMetricCalculated={Boolean(p.integralV2Metric)}
              label={label}
              scale={scale}
              size={size}
            />
          )}
        </OptMetricBar>
      );
    }

    return null;
  },
  iteratee(p) {
    if (p instanceof Diamond && p.integralV2Metric) {
      return p.integralV2Metric.val;
    }

    return null;
  },
  contexts: ALL_CONTEXTS,
};
